export default {
    title: '<span class="title">Adobe Campaign - API Documentation</span>',
    topics: [
        {
            title: ' API Release Notes ',
            href: 'releaseNotes.html',
            attributes: { 'data-id': 'p-1' },
            menu: { hasChildren: false },
            tocID: 'p-1-d66e11',
            topics: [],
        },
        { title: 'JavaScript', href: 'p-1.html', menu: { hasChildren: true }, tocID: 'tocId-d66e20', next: 'tocId-d66e20' },
        {
            title: 'Form',
            href: 'control-Button.html',
            menu: { hasChildren: true },
            tocID: 'tocId-d66e7888',
            next: 'tocId-d66e7888',
        },
    ],
};

